import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateLab = createAsyncThunk(
  "labs/updateLab",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateLab(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateLabSLice = createSlice({
  name: "updateLab",
  initialState,
  reducers: {
    clearUpdateLabResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateLab.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateLab.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateLab.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateLabList = (state) => state.updateLab.value;
export const updateLabLoader = (state) => state.updateLab.loading;
export const {clearUpdateLabResponse} = updateLabSLice.actions;

export default updateLabSLice.reducer;
